/**
 * UI slice — global UI state: notifications, sidebar, loading overlays.
 */

import { createSlice } from '@reduxjs/toolkit';

let nextId = 1;

const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        notifications: [],   // { id, message, severity, autoHide }
        sidebarOpen: true
    },
    reducers: {
        showNotification(state, action) {
            state.notifications.push({
                id: nextId++,
                severity: 'info',
                autoHide: true,
                ...action.payload
            });
        },
        dismissNotification(state, action) {
            state.notifications = state.notifications.filter(n => n.id !== action.payload);
        },
        toggleSidebar(state) {
            state.sidebarOpen = !state.sidebarOpen;
        }
    }
});

export const { showNotification, dismissNotification, toggleSidebar } = uiSlice.actions;

export const selectNotifications = (state) => state.ui.notifications;
export const selectSidebarOpen = (state) => state.ui.sidebarOpen;

export default uiSlice.reducer;
